import {
  IMAGE_ACCEPTED,
  ONE_MB,
  PDF_MIME_TYPE,
  TEXT_STRING,
} from '../../constants';

// backend の MALE_CHAT_UPLOAD_* と値を揃えること（management の ACCEPT_VIDEO と同一）
export const VIDEO_ACCEPTED = ['video/mp4', 'video/mov', 'video/quicktime'];
export const MAX_CHAT_PDF_SIZE = ONE_MB * 10; // 10MB
export const MAX_CHAT_VIDEO_SIZE = ONE_MB * 100; // 100MB
export const CHAT_VIDEO_MIME_PREFIX = 'video/';

// チャットに添付できる MIME の許可リスト。input の accept 属性と検証で共用する
export const CHAT_ACCEPTED_FILE_TYPES = [
  ...IMAGE_ACCEPTED,
  ...VIDEO_ACCEPTED,
  PDF_MIME_TYPE,
];

// accept 属性はダイアログの「すべてのファイル」で回避できるため、選択後にも検証する
export const isAcceptedChatFileType = (type?: string): boolean =>
  !!type && CHAT_ACCEPTED_FILE_TYPES.includes(type);

export type ChatFileKind = 'pdf' | 'video' | 'image';

// 添付ファイルの MIME からチャット上の種別を判定する。
// pdf / video 以外（未知 MIME・未指定を含む）は image にフォールバックする
export const getChatFileKind = (type?: string): ChatFileKind =>
  type === PDF_MIME_TYPE
    ? 'pdf'
    : type?.startsWith(CHAT_VIDEO_MIME_PREFIX)
    ? 'video'
    : 'image';

// 種別ごとの「送信しました」通知・プレビューラベル
export const CHAT_FILE_SENT_LABEL: Record<ChatFileKind, string> = {
  pdf: TEXT_STRING.MESSAGE.PDF_SENT,
  video: TEXT_STRING.MESSAGE.VIDEO_SENT,
  image: TEXT_STRING.MESSAGE.IMAGE,
};

// backend UpdateSentDto.text の @MaxLength と揃えること（超えると /sent が 400 になり運営へ通知が届かない）
export const SENT_TEXT_MAX_LENGTH = 1000;
